import { type Program, Programs } from '@repo/program-data';
import type { ColumnDef } from '@repo/ui';
import {
  Button,
  DataTable,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  useDataTable,
} from '@repo/ui';
import { link } from 'astro-typed-links/link';
import { SquareArrowOutUpRight } from 'lucide-react';
import { BadgeDisplay } from '../components/badge-display';
const columns: ColumnDef<Program>[] = [
  {
    accessorKey: 'name',
    header: 'Name',

    cell: ({ cell, row }) => {
      const slug = row.getValue<string>('slug');
      const value = cell.getValue<string>();
      return (
        <a
          aria-label="View"
          className="transition-colors hover:text-primary hover:underline"
          href={link('/programs/[program]', {
            params: { program: slug },
          })}
        >
          {value}
        </a>
      );
    },

    enableSorting: true,
  },
  {
    accessorKey: 'by',
    header: 'Organization',
    enableSorting: true,
    enableColumnFilter: true,
    filterFn: 'arrIncludesSome',
    getUniqueValues: (data) => {
      const org = data.by;
      if (org) {
        return [org];
      }
      return [];
    },
  },
  {
    accessorKey: 'overview',
    header: 'Overview',
    cell: ({ row }) => {
      const val: string = row.getValue('overview');
      return (
        <Tooltip>
          <TooltipTrigger>
            <div className="line-clamp-4">{val}</div>
          </TooltipTrigger>
          <TooltipContent>{val}</TooltipContent>
        </Tooltip>
      );
    },
  },
  {
    accessorKey: 'ages',
    header: 'Ages',
    cell: ({ row }) => {
      const value = row.getValue<string[]>('ages');
      return <BadgeDisplay value={value} />;
    },
    filterFn: 'arrIncludesSome',
    enableColumnFilter: true,
    getUniqueValues: (data) => {
      return data.ages;
    },
  },
  {
    accessorKey: 'curriculumTypes',
    header: 'Services',
    filterFn: 'arrIncludesSome',
    enableColumnFilter: true,
    cell: ({ row }) => {
      const value = row.getValue<string[]>('curriculumTypes');
      return <BadgeDisplay value={value} />;
    },
    getUniqueValues: (data) => {
      return data.curriculumTypes;
    },
  },

  {
    accessorKey: 'curriculumFocusAreas',
    header: 'Disciplines',
    filterFn: 'arrIncludesSome',
    enableColumnFilter: true,
    cell: ({ row }) => {
      const value = row.getValue<string[]>('curriculumFocusAreas');
      return <BadgeDisplay value={value} />;
    },
    getUniqueValues: (data) => {
      return data.curriculumFocusAreas;
    },
  },

  {
    accessorKey: 'location',
    header: 'Location',
    filterFn: 'arrIncludesSome',
    enableColumnFilter: true,
    getUniqueValues: (data) => {
      return [data.location].filter(Boolean);
    },
  },
  {
    accessorKey: 'slug',
    header: '',
    cell: ({ cell }) => {
      const value = cell.getValue<string>();
      return (
        <Button
          aria-label="View"
          className="text-sm"
          href={link('/programs/[program]', {
            params: { program: value },
          })}
          size="icon"
          variant="ghost"
        >
          <SquareArrowOutUpRight size={16} />
        </Button>
      );
      // return <a href={`/programs/${value}`}>View</a>;
    },
  },
];

export function ProgramsDataTable({ programs }: { programs: Program[] }) {
  //   const { db, findTodos } = useDatabase();
  //   const [data, setData] = useState<TodoDocType[]>([]);
  //   useEffect(() => {
  //     findTodos().then((res) => {
  //       if (res) {
  //         console.log("RES", res);
  //         setData(res);
  //       }
  //     });
  //   }, [db]);

  const model = useDataTable({
    columns,
    data: programs || Programs.instance.programs,
    enablePagination: true,
    // selectable: true,
  });

  return (
    <div>
      {/* <DataTableViewOptions table={model.table} /> */}
      <TooltipProvider>
        <DataTable {...model} />
      </TooltipProvider>
    </div>
  );
}
